import React from 'react';

import { Spinner } from '@rbilabs/universal-components';
import { StoreChangeDisclaimer } from 'features/store/pages/pickup-store-selector/components';
import { StyleSheet } from 'react-native';

import ActionButton from 'components/action-button';
import { Box } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

import { DeliveryTerms } from '../delivery-terms';

import { LoadingText } from './styled';

const BUTTON_CONTAINER_MAX_WIDTH = 576;

interface IDeliveryFormFooterProps {
  submitAddress: () => void;
  isDisabled: boolean;
  isLoading: boolean;
  isEditing?: boolean;
  showtermsLink?: boolean;
}

export const DeliveryAddressFormFooter: React.FC<React.PropsWithChildren<
  IDeliveryFormFooterProps
>> = ({ submitAddress, isDisabled, isLoading, isEditing, showtermsLink }) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <>
      {!showtermsLink ? (
        <Box
          style={[styles.buttonContainer, isDesktop && styles.buttonContainerDesktop]}
          testID="delivery-address-form-button-container"
        >
          <ActionButton
            onPress={submitAddress}
            fullWidth
            color={primitive.$white}
            mb="$4"
            disabled={isLoading || isDisabled}
            _disabled={{
              bg: primitive.$fieryRedOpacity30,
              color: primitive.$white,
              opacity: 1,
              borderWidth: 0,
            }}
            isLoading={isLoading}
            testID="deliver-here"
            rightIcon={
              isLoading ? (
                <Box style={styles.spinnerWrapper}>
                  <Spinner size="sm" color={primitive.$white} />
                </Box>
              ) : undefined
            }
            _text={{
              fontSize: 'lg',
              color: isLoading ? primitive.$bbqBrown : primitive.$white,
            }}
            _loading={{
              bg: primitive.$fieryRedOpacity30,
              borderWidth: 0,
              borderColor: primitive.$bbqBrown,
            }}
          >
            {isEditing ? t('upateAddress') : t('deliverHere')}
          </ActionButton>
        </Box>
      ) : (
        <Box style={styles.deliveryInfoContainer}>
          <DeliveryTerms />
          <StoreChangeDisclaimer />
        </Box>
      )}
      {!isEditing && isLoading && (
        <Box>
          <LoadingText>{t('deliveryCheckingMessage')}</LoadingText>
        </Box>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    alignSelf: 'center',
    marginVertical: spacing.$4,
    maxWidth: BUTTON_CONTAINER_MAX_WIDTH,
    paddingHorizontal: spacing.$4,
    width: '100%',
  },
  buttonContainerDesktop: {
    width: '50%',
  },
  deliveryInfoContainer: {
    alignSelf: 'center',
    marginVertical: spacing.$12,
  },
  spinnerWrapper: {
    alignItems: 'center',
    height: spacing.$4,
    justifyContent: 'center',
    width: spacing.$4,
  },
});
